var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhinovideoNotSupported(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "203px",
    height: "132px",
    viewBox: "0 0 203 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#0075C9",
    strokeWidth: 2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 1,
    y: 1,
    width: 201,
    height: 130,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#CC2D32",
    strokeWidth: 2,
    x: 76.0555556,
    y: 54.1666667,
    width: 39.7222222,
    height: 33.6111111,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#CC2D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "131.166667 81.6666667 118.944444 72.5 118.944444 66.3888889 131.166667 57.2222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0512828,39.577928 C97.4934564,39.5691685 97.8590098,39.92052 97.8677693,40.3626935 C97.8679027,40.36943 97.8679512,40.3761679 97.8679145,40.3829055 L97.5190293,104.584563 C97.5165465,105.041438 97.150264,105.413023 96.6934719,105.422072 C96.2512984,105.430832 95.8857449,105.07948 95.8769854,104.637306 C95.876852,104.63057 95.8768036,104.623832 95.8768402,104.617094 L96.2257255,40.4154374 C96.2282082,39.9585624 96.5944907,39.586977 97.0512828,39.577928 Z",
    id: "Rectangle",
    fill: "#CC2D32",
    transform: "translate(96.872377, 72.500000) rotate(45.000000) translate(-96.872377, -72.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0075C9",
    cx: 11,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0075C9",
    cx: 21,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0075C9",
    cx: 31,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0075C9",
    x: 1,
    y: 21,
    width: 200,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0075C9",
    x: 52,
    y: 8,
    width: 100,
    height: 7,
    rx: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhinovideoNotSupported);
export default __webpack_public_path__ + "static/media/rhinovideo-not-supported.9eb6f439.svg";
export { ForwardRef as ReactComponent };